import React from "react";

export const DefaultEmptyContent: React.FC = () => (
  <div className="flex items-center justify-center py-10 text-center text-sm text-gray-500">
    No users found
  </div>
);
